import { staticMediaUrl } from '@/fo/util/image-loader';
import { MediaGallery, Label } from '@/fo/util/map-product-data';

export const tagsMock: Label[] = [
  {
    name: 'New'
  },
  {
    name: '-20%',
    color: 'yellow'
  }
];

export const imagesMock: MediaGallery = [
  {
    id: '1',
    type: 'image',
    src: staticMediaUrl('product/bioderma.png'),
    alt: 'bioderma',
    roles: []
  },
  {
    id: '2',
    type: 'image',
    src: staticMediaUrl('product/bioderma_2.jpg'),
    alt: 'bioderma',
    roles: []
  },
  {
    id: '3',
    type: 'image',
    src: staticMediaUrl('product/bioderma_3.png'),
    alt: 'bioderma',
    roles: []
  },
  {
    id: '4',
    type: 'image',
    src: staticMediaUrl('product/bioderma_4.jpg'),
    alt: 'bioderma',
    roles: []
  },
  {
    id: '5',
    type: 'image',
    src: staticMediaUrl('product/bioderma_5.jpg'),
    alt: 'bioderma',
    roles: []
  },
  {
    id: '6',
    type: 'image',
    src: staticMediaUrl('product/bioderma_6.jpg'),
    alt: 'bioderma',
    roles: []
  },
  {
    id: '7',
    type: 'image',
    src: staticMediaUrl('product/bioderma_7.jpg'),
    alt: 'bioderma',
    roles: []
  },
  {
    id: '8',
    type: 'image',
    src: staticMediaUrl('product/bioderma_8.jpg'),
    alt: 'bioderma',
    roles: []
  }
];
